import robuxModule from "../robuxModule";

function robuxContainer($compile, $filter, premiumService, premiumConstants, premiumConstantsService) {
    "ngInject";

    return {
        restrict: "A",
        scope: false,
        templateUrl: premiumConstants.templates.robuxContainer,
        link: function (scope) {
            scope.subscribePageUrl = premiumService.getSubscriptionPageUrl();
            scope.isShowSuperValue = false; //default hide the super value session
            setPageDescriptionElement();

            scope.moreRobuxBtnClicked = function () {
                if (!scope.isShowSuperValue)
                    scope.isShowSuperValue = true;
                premiumService.sendInteractionClickEvent(premiumConstants.pageContext.robux,
                    premiumConstants.streamEventParams.wantMoreBtn);
            }

            scope.linkClicked = function (linkType) {
                premiumService.sendInteractionClickEvent(premiumConstants.pageContext.robux, linkType);
            }

            function setPageDescriptionElement() {
                var subtitleElement = angular.element(".top-subtitle");
                if (!subtitleElement.childElementCount) {
                    var helpLinkStart = "<a href=\"" + premiumConstantsService.links.robuxHelper + "\" class=\"text-link\" ng-click=\"linkClicked('" + premiumConstants.streamEventParams.robloxHelpLink + "')\">";
                    var learnMoreLinkStart = "<a ng-href={{subscribePageUrl}} class=\"text-link\" ng-click=\"linkClicked('" + premiumConstants.streamEventParams.learnMoreLink + "')\">";
                    var pageSubtitle = $filter('translate')('Description.BuyRobuxSubtitle', {
                        helpLinkStart: helpLinkStart,
                        helpLinkEnd: '</a>',
                        paragraphBreaker: '<br/>',
                        learnMoreLinkStart: learnMoreLinkStart,
                        learnMoreLinkEnd: '</a>'
                    });
                    var template = $compile('<span>' + pageSubtitle + '</span>')(scope);
                    subtitleElement.append(template);
                }
            }
        }
    }
}


robuxModule
    .directive("robuxContainer", robuxContainer);

export default robuxModule;